import React from "react"
import Img from "gatsby-image"

import { Image } from "../TestimonialsStyles"
import { withTestimonialsImage } from "./withTestimonialsImage"

export const TestimonialsImage = withTestimonialsImage(
  ({ active, image }): JSX.Element => (
    <Image active={active}>
      {image?.desktop && <Img alt={image?.desktop?.alt} fluid={{ ...image?.desktop, aspectRatio: 2 / 1 }} />}
      {image?.mobile && <Img alt={image?.mobile?.alt} fluid={{ ...image?.mobile, aspectRatio: 2 / 1 }} />}
    </Image>
  )
)
